<template>
  <PageWrapper :isLoading="isLoading">
    <template #title> کلاس های گروهی من </template>
    <CustomTable
      v-if="masterGroupClassList"
      :pageNumber="masterGroupClassFilters.pageNumber"
      :count="masterGroupClassFilters.count"
      :totalCount="totalCount"
      :tableColumns="tableColumns"
      :tableItems="masterGroupClassList"
      @changePage="changePage"
    >
      <template #actions="data">
        <BButton
          variant="transparent"
          size="sm"
          @click="renderJoinToGroupClassDialog(data.item)"
        >
          <FeatherIcon icon="UserCheckIcon" size="23" class="text-info" />
        </BButton>
      </template>
    </CustomTable>
    <UpdateGroupClassByMasterDialog
      :defaultSelectedGroupClass="tempSelectedGroupClass"
      @refetch="refetch"
    ></UpdateGroupClassByMasterDialog>
  </PageWrapper>
</template>

<script>
export default {
  emits: ["refetch"],
  mounted() {
    this.getAllMasterGroupClasses();
  },
  data() {
    return {
      isLoading: false,
      masterGroupClassList: null,
      totalCount: null,
      tempSelectedGroupClass: null,
      masterGroupClassFilters: {
        masterId: null,
        pageNumber: 1,
        count: 10,
      },
      tableColumns: [
        {
          key: "groupClassId",
          label: "شناسه",
        },
        {
          key: "name",
          label: "عنوان کلاس",
        },
        {
          key: "duration",
          label: "حداقل زمان کلاس",
          formatter: (value) => `${value} دقیقه`,
        },
        {
          key: "minUserCapacity",
          label: "حداقل تعداد شرکت کننده ها",
          formatter: (value) => `${value} نفر`,
        },
        {
          key: "maxUserCapacity",
          label: "حداکثر تعداد شرکت کننده ها",
          formatter: (value) => `${value} نفر`,
        },
        {
          key: "masterBasePrice",
          label: "قیمت پایه استاد",
          formatter: (value, _, item) =>
            `${Intl.NumberFormat("en-US").format(value)} تومان (به ازای هر${
              item.duration
            } دقیقه)`,
        },
        {
          key: "actions",
          label: "عملیات",
        },
      ],
    };
  },
  methods: {
    refetch() {
      this.$emit("refetch");
      this.getAllMasterGroupClasses();
    },
    renderJoinToGroupClassDialog(selectedGroupClass) {
      this.tempSelectedGroupClass = selectedGroupClass;
      this.$bvModal.show("update-group-class-by-master-dialog");
    },
    changePage(pageNumber) {
      this.masterGroupClassFilters.pageNumber = pageNumber;
      this.getAllMasterGroupClasses();
    },
    async getAllMasterGroupClasses() {
      try {
        this.masterGroupClassFilters.masterId = getUserData().user.userId;
        this.isLoading = true;
        const _this = this;
        const getMasterAssignedGroupClasses = new GetMasterAssignedGroupClasses(
          _this
        );
        getMasterAssignedGroupClasses.setRequestParam(
          _this.masterGroupClassFilters
        );
        await getMasterAssignedGroupClasses.fetch((res) => {
          if (res.isSuccess) {
            _this.masterGroupClassList = res.data.data;
            _this.totalCount = res.data.total;
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  components: {
    PageWrapper,
    CustomTable,
    UpdateGroupClassByMasterDialog,
    BButton,
  },
};
import PageWrapper from "@/views/components/Utils/PageWrapper.vue";
import CustomTable from "@/views/components/Utils/CustomTable.vue";
import UpdateGroupClassByMasterDialog from "@/views/components/GroupClass/UpdateGroupClassByMasterDialog.vue";
import { BButton } from "bootstrap-vue";
import { getUserData } from "@/auth/utils";
import { GetMasterAssignedGroupClasses } from "@/libs/Api/GroupClass";
</script>
